import api from "./base";

/**
 * Connect Google Calendar by exchanging authorization code for tokens
 * @param {string} code - Authorization code from Google OAuth
 * @returns {Promise<Object>} Response from the server
 */
export async function connectGoogleCalendar(code) {
    const res = await api.post("/calendar/connect", { code });
    return res.data;
}

/**
 * Fetch connected Google Calendar tokens
 * @returns {Promise<Array>} Array of GoogleCalendarToken objects
 */
export async function fetchGoogleCalendarTokens() {
    const res = await api.get("/calendar");
    return res.data;
}

/**
 * Delete a Google Calendar token
 * @param {number} tokenId - ID of the token to delete
 * @returns {Promise<Object>} Response from the server
 */
export async function deleteGoogleCalendarToken(tokenId) {
    const res = await api.post("/calendar/delete", { tokenId });
    return res.data;
} 